import React, { useState } from 'react';
import WhatsAppAnalysis from './WhatsAppAnalysis';
import EmailAnalysis from './EmailAnalysis';
import CommuniCaptureHelp from './CommuniCaptureHelp';

export default function CommuniCapture() {
  const [activeTab, setActiveTab] = useState('whatsapp');
  const [listData, setListData] = useState(null);

  const openList = async () => {
    try {
      const res = await fetch('/communicatputre-list');
      const data = await res.json();
      setListData(data || []);
      setActiveTab('list');
    } catch (err) {
      setListData([{ id: 1, note: 'Fallback item (offline mode)' }]);
      setActiveTab('list');
    }
  };

  return (
    <div className="p-4 bg-black text-white w-full">
      <h2 className="text-lg lg:text-xl font-semibold mb-2 text-yellow-200">CommuniCapture</h2>

      {/* Tabs */}
      <div className="flex space-x-2 mb-4 text-sm">
        <button className={`px-3 py-2 rounded ${activeTab==='whatsapp'?'bg-blue-600':'bg-gray-700'}`} onClick={()=>setActiveTab('whatsapp')}>WhatsApp Analysis</button>
        <button className={`px-3 py-2 rounded ${activeTab==='email'?'bg-blue-600':'bg-gray-700'}`} onClick={()=>setActiveTab('email')}>Email Analysis</button>
        <button className={`px-3 py-2 rounded ${activeTab==='list'?'bg-blue-600':'bg-gray-700'}`} onClick={openList}>List</button>
        <button className={`px-3 py-2 rounded ${activeTab==='help'?'bg-blue-600':'bg-gray-700'}`} onClick={()=>setActiveTab('help')}>Help</button>
      </div>

      {/* Tab Content */}
      {activeTab === 'whatsapp' && <WhatsAppAnalysis />}
      {activeTab === 'email' && <EmailAnalysis />}

      {activeTab === 'list' && (
        <div className="bg-black p-4 rounded">
          <h3 className="text-lg mb-2">Saved Records</h3>
          <ul className="space-y-2">
            {listData?.map((item) => (
              <li key={item.id} className="p-2 bg-gray-700 rounded">{JSON.stringify(item)}</li>
            ))}
          </ul>
        </div>
      )}

      {activeTab === 'help' && <CommuniCaptureHelp />}
    </div>
  );
}
